import { useRef, useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";
import C from "classnames";

import { buildRoute } from "sj-ui-toolkit/src/constants/routes";
import { useSmartNavigation } from "sj-ui-toolkit/src/helpers/navigation";

import S from "./DashboardCard.module.scss";

export const AssignmentCard = ({
  name,
  description,
  dueDate,
  progress,
  roleId,
  type = "path",
  tagText = "Assignment",
  onNavigate,
}) => {
  const { navigateTo } = useSmartNavigation();
  const descriptionRef = useRef(null);
  const [isClamped, setIsClamped] = useState(false);

  const descriptionText = description || "Complete assigned path";

  useEffect(() => {
    const element = descriptionRef.current;
    if (element) {
      setIsClamped(element.scrollHeight > element.clientHeight);
    }
  }, [descriptionText]);

  const navigateToAssignment = () => {
    if (onNavigate) {
      onNavigate();
      return;
    }
    if (type === "quest") {
      navigateTo(buildRoute("Learn.routes.quest.route", { pathId: roleId }));
    } else {
      navigateTo(buildRoute("Learn.routes.path.route", { pathId: roleId }));
    }
  };

  const formatDate = dateString => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    } catch (_error) {
      return dateString;
    }
  };

  const progressPercent = progress?.percents || 0;

  return (
    <div className={S.assessmentCard} onClick={navigateToAssignment}>
      <svg className={S.completionBadge} width="90" height="101" viewBox="0 0 90 101" fill="none">
        <circle cx="61" cy="40" r="60.1286" stroke="#9EA0A2" strokeWidth="1.74286" />
        <circle cx="60.9996" cy="39.9994" r="49.9297" stroke="#9EA0A2" strokeWidth="1.74286" />
        <path
          d="M38.4851 44.0536L49.7456 59.5895L83.5197 20.4121"
          stroke="#9EA0A2"
          strokeWidth="1.74286"
        />
      </svg>
      <div className={S.assessmentCardHeader}>
        <Tag value={tagText} severity="success" rounded={true} />
      </div>
      <div className={S.assessmentCardBody}>
        <h3 className="atlas-h4">{name}</h3>
        <p
          ref={descriptionRef}
          className={C("body-md", S.clampedText)}
          data-pr-tooltip={isClamped ? descriptionText : null}
          data-pr-position="bottom"
          data-pr-classname={S.descriptionTooltip}
        >
          {descriptionText}
        </p>
        {isClamped && <Tooltip target={descriptionRef} style={{ maxWidth: "400px" }} />}
      </div>
      <div className={S.assessmentDetailsWrapper}>
        <div>
          <p className={C(S.mutedText, "body-sm")}>Due Date</p>
          <p className="body-md">{dueDate ? formatDate(dueDate) : "No due date"}</p>
        </div>
        <div>
          <p className={C(S.mutedText, "body-sm")}>Progress</p>
          <p className="body-md">{progressPercent}%</p>
        </div>
        <div>
          <p className={C(S.mutedText, "body-sm")}>Completed</p>
          <p className="body-md">
            {progress?.passed || 0}/{progress?.all || 0}
          </p>
        </div>
      </div>
      <div className={S.assessmentCardFooter}>
        <Button
          label="View Assignment"
          onClick={e => {
            e.stopPropagation();
            navigateToAssignment();
          }}
        />
      </div>
    </div>
  );
};
